import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../../Constant";
import CustomerForm from "./CustomerForm";

const CustomerAdd = () => {
    return (
        <Fragment>
            <CustomerForm mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default CustomerAdd;